export const api_url = 'https://bca-x-ramadhan.labs.devitright.com/wp-json'
